import { requestType } from "../constants/Variables";
import Api from "./index";

// ======================== Content Posts ========================

export const generateContent = (params) => {
  return Api("content/generate", params, requestType.POST);
};

export const getAllContent = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.status) queryParams.append("status", params.status);
  if (params.search) queryParams.append("search", params.search);

  const finalUrl = queryParams.toString()
    ? `content/all?${queryParams.toString()}`
    : "content/all";

  return Api(finalUrl, null, requestType.GET);
};

export const getContentById = (id) => {
  return Api(`content/get/${id}`, {}, requestType.GET);
};

export const updateContent = (id, params) => {
  return Api(`content/update/${id}`, params, requestType.PUT);
};

export const approveContent = (id) => {
  return Api(`content/approve/${id}`, {}, requestType.PATCH);
};

export const rejectContent = (id) => {
  return Api(`content/reject/${id}`, {}, requestType.PATCH);
};

export const regenerateContent = (id, params) => {
  return Api(`content/regenerate/${id}`, params, requestType.POST);
};

export const generateImageForChannel = (id, params) => {
  return Api(`content/generate-image/${id}`, params, requestType.POST);
};

export const publishNow = (id, params) => {
  return Api(`content/publish-now/${id}`, params, requestType.POST);
};

export const scheduleContent = (id, params) => {
  return Api(`content/schedule/${id}`, params, requestType.POST);
};

export const cancelSchedule = (id) => {
  return Api(`content/schedule/${id}`, {}, requestType.DELETE);
};

export const deleteContent = (id) => {
  return Api(`content/delete/${id}`, {}, requestType.DELETE);
};

// --- Analytics ---
export const getAnalyticsSummary = () => {
  return Api(`content/analytics/summary`, {}, requestType.GET);
};

export const getPostAnalytics = (id) => {
  return Api(`content/analytics/${id}`, {}, requestType.GET);
};

// --- Automation Schedules ---
export const createContentSchedule = (params) => {
  return Api(`content-schedules`, params, requestType.POST);
};

export const getAllContentSchedules = () => {
  return Api(`content-schedules`, {}, requestType.GET);
};

export const updateContentSchedule = (id, params) => {
  return Api(`content-schedules/${id}`, params, requestType.PUT);
};

export const toggleContentSchedule = (id) => {
  return Api(`content-schedules/${id}/toggle`, {}, requestType.PATCH);
};

export const deleteContentSchedule = (id) => {
  return Api(`content-schedules/${id}`, {}, requestType.DELETE);
};

// ======================== Brand Profiles ========================

export const createBrandProfile = (params) => {
  return Api("brand-profile/create", params, requestType.POST);
};

export const getAllBrandProfiles = () => {
  return Api("brand-profiles", null, requestType.GET);
};

export const getBrandProfileById = (id) => {
  return Api(`brand-profile/get/${id}`, {}, requestType.GET);
};

export const updateBrandProfileApi = (id, params) => {
  return Api(`brand-profile/update/${id}`, params, requestType.PUT);
};

export const deleteBrandProfile = (id) => {
  return Api(`brand-profile/delete/${id}`, {}, requestType.DELETE);
};

// ======================== Products (for selector) ========================

export const searchProducts = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit || 20);

  const url = queryParams.toString()
    ? `supplier/product/get-all?${queryParams.toString()}`
    : "supplier/product/get-all";

  return Api(url, null, requestType.GET);
};
